import React, { createContext, useState, useContext, useEffect } from 'react';
import { authAPI } from '../services/api';

const AuthContext = createContext({});

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    try {
      const result = await authAPI.getCurrentUser();
      if (result.success) {
        setCurrentUser(result.user);
      } else {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
      }
    } catch (error) {

      localStorage.removeItem('token');
      localStorage.removeItem('user');
    } finally {
      setLoading(false);
    }
  };

  const login = async (email, password) => {
    setLoading(true);
    try {
      const result = await authAPI.login(email, password);
      if (result.success && result.token) {
        setCurrentUser(result.user);
        localStorage.setItem('token', result.token);
        localStorage.setItem('user', JSON.stringify(result.user));
        return { success: true };
      } else {
        return { 
          success: false, 
          error: result.error || 'Login failed. Please check your credentials.' 
        };
      }
    } catch (error) {
      return { 
        success: false, 
        error: error.error || 'Login failed. Please check your credentials.' 
      };
    } finally {
      setLoading(false);
    }
  };

  const register = async (userData) => {
    try {
      const result = await authAPI.register(userData);
      return result;
    } catch (error) {
      return { 
        success: false, 
        error: error.error || 'Registration failed.' 
      };
    }
  };

  const logout = async () => {
    try {
      await authAPI.logout();
    } catch (error) {

    } finally {
      setCurrentUser(null);
      localStorage.removeItem('token');
      localStorage.removeItem('user');
    }
  };

  const resetPassword = async (email) => {
    try {
      const result = await authAPI.forgotPassword(email);
      return { 
        success: result.success, 
        message: result.message || 'Password reset link sent to your email.' 
      };
    } catch (error) {
      return { 
        success: false, 
        error: error.error || 'Failed to send reset link.' 
      };
    }
  };

  const updateProfile = async (userData) => {
    try {
      const result = await authAPI.updateProfile(userData);
      if (result.success) {
        setCurrentUser(result.user);
        localStorage.setItem('user', JSON.stringify(result.user));
      }
      return result;
    } catch (error) {
      return { 
        success: false, 
        error: error.error || 'Failed to update profile.' 
      };
    }
  };

  const value = {
    currentUser,
    login,
    register,
    logout,
    resetPassword,
    updateProfile,
    loading
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};